//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DeliveryLogList from './delivery-log-list';
import fileUploader from '../../../common-components/file-uploader';
import { formatDate } from '../../../../lib/date';
import DeliveryOtherOwner from './delivery-otherOwner';
import DeliveryEmergencyContactInfo from './delivery-emergencyContactInfo';

export default {
    name: 'page-detail-deliver',
    components: { DeliveryEmergencyContactInfo, DeliveryOtherOwner, DeliveryLogList, fileUploader },
    props: {
        roomId: {
            type: Number,
            required: true
        }
    },
    data() {
        const vm = this;
        return {
            loading: false,
            saving: false,
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            searchInput: {},
            list: [],
            columns: [
                {
                    key: 'id', title: '单号', align: 'center', minWidth: 200,
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        let code = row.deliveryCode;
                        if (code == null || code === '') {
                            code = '未填写';
                        }
                        actions.push(
                            h('a', {
                                    on: {
                                        click: function() {
                                            vm.showDeliveryInfo(row);
                                        }
                                    }
                                },
                                code
                            )
                        );
                        return actions;
                    }
                },
                {
                    title: '计划名称', minWidth: 99, key: 'planName', align: 'center',
                    render: (h, params) => {
                        let row = params.row;
                        let actions = [];
                        actions.push(
                            h('a', {
                                on: {
                                    click: function() {
                                        vm.$router.push({
                                            name: 'deliveryPlanInfo',
                                            params: {
                                                planId: row.planId
                                            }
                                        });
                                    }
                                }
                            }, row.planName));
                        return actions;
                    }
                },
                {
                    title: '预约时间', minWidth: 110, key: '', align: 'center',
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        let str = '';
                        if (row.deliveryTimeStr) {
                            str = str + row.deliveryTimeStr;
                        }
                        if (row.time) {
                            str = str + ' ' + row.time;
                        }
                        // let str = row.deliveryTimeStr ? row.deliveryTimeStr : '';
                        // str = str + row.time ? row.time : '';
                        // const d = actions.push(h('p', str));
                        return h('span', str);
                    }
                },
                // { title: '预约来源', align: 'center', minWidth: 99, key: 'deliverySourceStr' },
                {
                    title: '项目名称', align: 'center', key: 'projectName', minWidth: 99
                },
                {
                    title: '房间', align: 'center', key: 'roomName', minWidth: 250
                },
                {
                    key: 'name', align: 'center', title: '联系信息', minWidth: 200,
                    render(h, params) {
                        let row = params.row;
                        let actions = [];
                        actions.push(h('p', '联系人：' + row.name));
                        actions.push(h('p', '联系电话：' + row.mobile));
                        return h('div', actions);
                    }
                },
                {
                    key: 'content', align: 'center', title: '预约说明', width: 200,
                    render(h, params) {
                        let content = '';
                        let row = params.row;
                        if (row.content != null && row.content !== '') {
                            if (row.content.length > 20) {
                                content = row.content.substring(1, 20) + '...';
                            } else {
                                content = row.content;
                            }
                        }
                        return h('Poptip', {
                            props: {
                                trigger: 'hover',
                                // title:' 11',
                                placement: 'bottom'
                            }
                        }, [
                            h('div', content),
                            h('div', {
                                slot: 'content',
                                style: {
                                    // width: "300px",
                                    // height: "100px",
                                    overflow: 'hidden',
                                    whiteSpace: 'normal'
                                }
                            }, [
                                h('div', row.content)
                            ])
                        ]);
                    }
                },
                {
                    title: '资料状态', align: 'center', minWidth: 99, key: 'dataStatusStr'
                },
                {
                    title: '预约状态', minWidth: 99, align: 'center', key: 'appointmentStatusStr'
                }
                // {
                //     title: '交房状态', minWidth: 99, align: 'center', key: 'deliveryStatusStr'
                // }
                // {
                //     key: 'statusStr', align: 'center', minWidth: 99,
                //     title: '状态'
                // }
                // {
                //     title: '操作',
                //     key: '',
                //     render: (h, params) => {
                //         let row = params.row;
                //         let actions = [];
                //         if (row.status == 11) {
                //             actions.push(h('Button', {
                //                 props: {
                //                     type: 'primary',
                //                     size: 'small'
                //                 },
                //                 style: {
                //                     // marginRight: '5px'
                //                 },
                //                 on: {
                //                     click: () => {
                //                          vm.dataAudit(params.row);
                //                     }
                //                 }
                //             }, '资料审核'));
                //         }
                //         return h('div', actions);
                //     }
                // }
            ]
        };
    },
    filters: {
        formatDate(time, type) {
            const date = new Date(time);
            if (type === 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    methods: {
        pageChange(page) {
            this.currentPage = page;
            this.getPage();
        },
        pageSizeChange(pagesize) {
            this.pageSize = pagesize;
            this.getPage();
        },
        getPage() {
            this.loading = true;
            this.searchInput.roomId = this.roomId;
            this.searchInput.maxResultCount = this.pageSize;
            this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
            abp.ajax.post('/api/services/app/DeliveryRecord/SearchDeliveryRecords', this.searchInput).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
                this.totalCount = res.data.result.totalCount;
            }).finally(() => {
                this.loading = false;
            });
        },
        showDeliveryInfo(row) {
            this.$router.push({
                path: '/reservationInfo/' + row.id
            });
        }
    },
    created() {
        this.getPage();
    }

};
